module.exports = __webpack_public_path__ + "images/emoji/mountain_cableway.a73976c56e8f9fb752d9.png";